import { FormErrorMessage, FormSection } from '@ksyos/design-system';
import type { BariPreCloseProcessPrematurelyData } from '@common/validation/customControls/bariPre/bariPreCloseProcessPrematurely/v1/bariPreCloseProcessPrematurelySchemaV1';
import { getDisplayName } from '@common/utils/getDisplayName';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { AlertCheckbox } from '../../AlertCheckbox';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function BariPreCloseProcessPrematurelyEdit(): JSX.Element {
    const { data, errors, onChange } = useProcessActivityEditContext<BariPreCloseProcessPrematurelyData>();
    const { patient } = usePatientEpisodeCategoryContext();
    const patientName = getDisplayName(patient, false, 'initialsFamilyName');
    const notification =
        `Als je akkoord gaat, stopt patiënt ${patientName} definitief met het voortraject Obesitas. Dit betekent ` +
        'dat de patiënt niet meer aangemeld kan worden voor het natraject. Dit kun je niet ongedaan maken.';

    return (
        <FormSection>
            <TextAreaFormGroup
                fieldKey="reden_besluit"
                isRequired={true}
                label="Reden besluit"
                placeholder="Reden voor besluit..."
            />

            <AlertCheckbox
                checked={data.sluit_proces}
                hasError={true}
                hasIcon={true}
                onChange={(checked) => onChange({ sluit_proces: checked }, 'sluit_proces')}
                text="Ja, ik ga akkoord met het beëindigen van het voortraject"
                title={notification}
            />
            {errors.has('sluit_proces') && (
                <FormErrorMessage sx={{ mt: 0 }}>
                    Je bent nog niet akkoord gegaan. Vink het vakje aan om aan te geven dat je akkoord gaat.
                </FormErrorMessage>
            )}
        </FormSection>
    );
}
